// extracted by mini-css-extract-plugin
var _1 = "Checkboxes-modulerightMargin__PJ_y_";
export { _1 as "rightMargin" }
